<script setup lang="ts">
import { useConfigStore } from '@/features/config/configStore';

const configStore = useConfigStore();
</script>

<template>
  <footer class="app-footer">
    <div class="footer-content">
      <div class="footer-brand">
        <a href="https://noriagentic.com" target="_blank" class="footer-logo">
          <img
            v-if="configStore.orgCreatedLogo"
            :src="configStore.orgCreatedLogo"
            class="nori-logo custom-footer-logo"
            width="20"
            height="20"
            alt="Logo"
          />
          <svg
            v-else
            class="nori-logo"
            width="20"
            height="20"
            viewBox="0 0 32 32"
            fill="none"
          >
            <rect
              x="1"
              y="11"
              width="20"
              height="20"
              rx="2"
              fill="#065c0e"
              stroke="#000"
              stroke-width="1.5"
            />
            <rect
              x="11"
              y="1"
              width="20"
              height="20"
              rx="2"
              fill="#065c0e"
              stroke="#000"
              stroke-width="1.5"
            />
          </svg>
          noriagentic.com
        </a>
      </div>

      <div class="footer-links">
        <div class="footer-column">
          <h4>Product</h4>
          <ul>
            <li>
              <a href="https://norisessions.com/" target="_blank">Sessions</a>
            </li>
            <li>
              <a
                href="https://github.com/tilework-tech/nori-cli"
                target="_blank"
                >CLI</a
              >
            </li>
            <li>
              <a href="https://noriskillsets.dev/" target="_blank"
                >Skillsets</a
              >
            </li>
            <li>
              <a href="/docs/building-a-skillset">Docs</a>
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h4>Community</h4>
          <ul>
            <li>
              <a
                href="https://join.slack.com/t/nori-7sp2119/shared_invite/zt-3ncc4qt8j-KB65S_FSt~ECLyMU_t4Veg"
                target="_blank"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zm1.271 0a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zm0 1.271a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zm10.124 2.521a2.528 2.528 0 0 1 2.52-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.52V8.834zm-1.271 0a2.528 2.528 0 0 1-2.521 2.521 2.528 2.528 0 0 1-2.521-2.521V2.522A2.528 2.528 0 0 1 15.166 0a2.528 2.528 0 0 1 2.521 2.522v6.312zm-2.521 10.124a2.528 2.528 0 0 1 2.521 2.52A2.528 2.528 0 0 1 15.166 24a2.528 2.528 0 0 1-2.521-2.522v-2.52h2.521zm0-1.271a2.528 2.528 0 0 1-2.521-2.521 2.528 2.528 0 0 1 2.521-2.521h6.312A2.528 2.528 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.521h-6.312z"
                  />
                </svg>
                Slack
              </a>
            </li>
            <li>
              <a href="https://github.com/tilework-tech" target="_blank">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"
                  />
                </svg>
                GitHub
              </a>
            </li>
          </ul>
        </div>

        <div class="footer-column">
          <h4>Contact</h4>
          <ul>
            <li>
              <a href="mailto:contact@tilework.tech">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                  />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
                contact@tilework.tech
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.app-footer {
  border-top: 1px solid var(--border);
  padding: 3rem 2rem 2rem;
  margin-top: auto;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  gap: 3rem;
  margin-bottom: 2rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.footer-brand {
  flex-shrink: 0;
}

.footer-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--foreground);
  text-decoration: none;
}

.footer-logo:hover {
  color: var(--accent);
}

.custom-footer-logo {
  object-fit: contain;
}

.footer-links {
  display: flex;
  gap: 4rem;
}

.footer-column h4 {
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--foreground);
  margin: 0 0 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-column li {
  margin-bottom: 0.5rem;
}

.footer-column a {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: var(--muted-foreground);
  text-decoration: none;
  transition: color 0.15s;
}

.footer-column a:hover {
  color: var(--foreground);
}

.footer-column svg {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 2rem;
  }

  .footer-links {
    flex-wrap: wrap;
    gap: 2rem;
  }
}
</style>
